import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';

import { actions } from 'features/domains/redux';

const ITEMS_ON_PAGE = 7;

export default function useDomains(enabled = true) {
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: '',
    domainRequestText: '',
    page: 1,
  });
  const [requestType, setRequestType] = useState('my-requests');
  const dispatch = useDispatch();
  const { totalCount, domainRequests, agentDomains } = useSelector(state => state.domains);

  const openModal = ({ isOpen, type = '', domainRequestText = '' }) => {
    setModalState({
      isOpen,
      type,
      domainRequestText,
      page: modalState.page,
    });
  };

  const changeRequestType = type => {
    setRequestType(type);
  };

  const sendDomainRequest = useCallback(
    closeFunction => {
      if (!enabled) return;

      dispatch(
        actions.sendDomainRequest(modalState.domainRequestText, () => {
          closeFunction();
          dispatch(actions.getDomains());
        }),
      );
    },
    [dispatch, enabled, modalState.domainRequestText],
  );

  const handlePageChange = useCallback(
    pageIndex => {
      if (!enabled) return;

      const pageForApi = pageIndex + 1;

      dispatch(actions.getMyDomains({ page: pageForApi, count: ITEMS_ON_PAGE }));

      setModalState(prev => ({
        ...prev,
        page: pageForApi,
      }));
    },
    [dispatch, enabled, setModalState],
  );

  useEffect(() => {
    if (!enabled) return;

    dispatch(actions.getDomains());
    dispatch(actions.getMyDomains({ page: 1, count: ITEMS_ON_PAGE }));
  }, [dispatch, enabled]);

  return {
    modalState,
    openModal,
    changeRequestType,
    requestType,
    sendDomainRequest,
    domainRequests,
    agentDomains,
    handlePageChange,
    ITEMS_ON_PAGE,
    totalCount,
  };
}
